export interface RelanceTemplate {
    objet: string;
    titre: string;
    corps: string;
    politesse: string;
}

export namespace RelanceTemplate {
    export interface Level {
        label: string;
        /** "mail" (Mail 1 et 2) ou "courrier" (LRAR 1, MED 1 à 3) */
        type: string;
    }

    export interface Collection {
        levels: { [level: number]: Level };
        templates: { [level: number]: RelanceTemplate };
    }

    /**
     * Variables substituées au moment de la relance, dans les quatre champs.
     * Voir buildVars() dans resources/assets/react/relance_clients_v3/relance_clients_v3.jsx
     * et l'en-tête de config/relance.php.
     */
    export const variables = [
        { name: "copropriete", description: "nom de la copropriété" },
        { name: "syndic", description: "nom du syndic" },
        { name: "date", description: "date du jour, jj/mm/aaaa" },
        { name: "ville", description: "ville de la société" },
        { name: "signataire", description: "signataire du courrier" },
        { name: "total", description: "total dû, ex. 1 234,56 €" },
        {
            name: "numeros_factures",
            description: "numéros des factures, séparés par « / »",
        },
        {
            name: "detail_factures",
            description: "liste des factures, une par ligne",
        },
        { name: "nb_factures", description: "nombre de factures" },
        { name: "facture_s", description: "« facture » / « factures »" },
        {
            name: "la_les_factures",
            description: "« la facture » / « les factures »",
        },
        {
            name: "la_les_factures_maj",
            description: "« LA FACTURE » / « LES FACTURES »",
        },
        {
            name: "de_la_des_factures",
            description: "« de la facture n° » / « des factures n° »",
        },
        {
            name: "detail_intro",
            description: "« Détail de la facture » / « Détail des factures »",
        },
        {
            name: "reference_factures",
            description:
                "« à la facture ci-dessus référencée » / « aux factures ci-dessus référencées »",
        },
        {
            name: "facture_impayee",
            description: "« Facture impayée » / « Factures impayées »",
        },
        {
            name: "facture_impayee_maj",
            description: "« FACTURE IMPAYEE » / « FACTURES IMPAYEES »",
        },
    ];
}
